import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function MobileHandoff() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(true);
  const token = new URLSearchParams(window.location.search).get("token");

  useEffect(() => {
    const verifyHandoff = async () => {
      if (!token) {
        setError("Missing handoff token. Please log in manually.");
        setIsVerifying(false);
        return;
      }

      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || "https://backend-ewrn.onrender.com"}/delivery/agent/verify-handoff`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token }),
        });

        const data = await res.json();

        if (res.ok && data.success) {
          localStorage.setItem("mm-agent", JSON.stringify(data.agent));
          localStorage.setItem("mm-agent-token", data.token);
          navigate("/delivery/agent", { replace: true });
          return;
        }

        setError(data.message || "Verification failed. Please log in manually.");
      } catch (err) {
        setError("Unable to verify your session right now. Please log in manually.");
      } finally {
        setIsVerifying(false);
      }
    };

    verifyHandoff();
  }, [navigate, token]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8fafc",
        padding: "16px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 15px 40px rgba(15, 23, 42, 0.12)",
          padding: "24px",
          textAlign: "center",
        }}
      >
        {isVerifying ? (
          <h2 style={{ margin: 0, color: "#0f172a", fontSize: "22px" }}>
            Securing your mobile session...
          </h2>
        ) : (
          <>
            <h2 style={{ margin: "0 0 10px 0", color: "#0f172a", fontSize: "22px" }}>
              Mobile Handoff Failed
            </h2>
            <p style={{ margin: "0 0 20px 0", color: "#475569", fontSize: "14px", lineHeight: 1.5 }}>
              {error}
            </p>
            <button
              onClick={() => navigate("/delivery/agent")}
              style={{
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                background: "#2563eb",
                color: "#ffffff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Back to Manual Login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
